import * as z from "zod/mini";

// The punch the verify panel shows; set by Time and Attendance rows and by links from Home and the pay dialog.
export const verifyPunchSearchSchema = {
  verify_punch: z.optional(z.string()),
};
